import { motion } from "framer-motion";

export default function LoadingScreen({
  text = "Yükleniyor...",
  fullScreen = false,
}: {
  text?: string;
  fullScreen?: boolean;
}) {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? "h-screen" : "flex-1 h-full min-h-48"}`}>
      <motion.div
        className="flex flex-col items-center gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="relative w-10 h-10">
          <div className="absolute inset-0 rounded-full border-2 border-white/[0.06]" />
          <div
            className="absolute inset-0 rounded-full border-2 border-transparent border-t-myGreen animate-spin"
          />
        </div>
        <p className="text-sm text-white/30">{text}</p>
      </motion.div>
    </div>
  );
}
